<template>
    <div class="agents-information">
		<div class="offline-message" v-if="showAvailability">
			{{ nextAvailableBusinessHours=='Away' ? replyTimeLabel : nextAvailableBusinessHours }}
		</div>
		<div class="agents-pictures" :style="{ margin: avatarMarginY+'px'+' 0px'}">
			<div class="picture" :key="index" v-for="(agent,index) in selectedAgent">
				<div v-if="!agent.imageURL" class="rp-no-image" :style="{ height: avatarSize+'px', width: avatarSize+'px' }">
					{{ agentInitial(agent) }}
				</div> 
				
				<img v-else
					:src="agent.imageURL" 
					:width="avatarSize"
					:height="avatarSize"
					:style="{borderRadius: '50%', border: borderForAvatar}"
					@error="errorMethod(agent)"
				/> 
				<!-- <template v-if="showOnlineStatus">
					<div v-if="isAgentOnline(agent)" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info"></div>
				</template>
				<template v-if="showOnlineStatusOnLastUser && index===selectedAgent.length-1">
					<div class="rp-helpdesk-conversation-list-item-online-status-in-agents-info"></div>
				</template> -->
			</div>
		</div>
		
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {

	props: {
		showOnlineStatusOnLastUser: {
			type: Boolean,
			default: false,
		},
		
		replyTimeLabel: {
			type: String,
			required: true
		},
		teamToRespond: {
			type: String,
			required: true,
		},
		nextAvailableBusinessHours: {
			type: String,
			required: true,
		},
		maxUser: {
			type: Number,
			default: 6,
		},

		avatarSize: {
			type: Number,
			default: 50
		},
		showAvailability: {
			type: Boolean,
			default: true
		},
		avatarMarginY: {
			type: Number,
			default: 10
		},
		borderForAvatar: {
			type: String,
			default: '2px solid white'
		},
		showOnlineStatus: {
			type: Boolean,
			default: true,
		}

	},
	methods: {
		errorMethod(agent){
			agent.imageURL = '';
			console.log("Error Method")
		},

		agentInitial(agent){
			if(agent.firstName && agent.lastName)
			return agent.firstName[0].toLowerCase() + ' ' + agent.lastName[0].toLowerCase()
		},
		isAgentOnline({ id }) {
			return this.activeAgentList.findIndex((agent)=> agent.operatorId === id) >= 0;
		},
	},
	computed: {

		...mapGetters({
			agentList: 'agentList',
			getMembersOfATeam: 'getMembersOfATeam',
			activeAgentList: 'activeAgentList',
		}),

		selectedAgent() {
			let teamMembers = []
			const agentList = this.getMembersOfATeam(this.teamToRespond)
			Object.keys(agentList).map(key => {
				const agent = agentList[key];
				//checking for invitation acceptance
				//Name first name and last name means 
				//invitation not yet accepted
				//so skip them 
				if(agent.firstName && agent.lastName && agent.isChatAccess !== false) {
					teamMembers.push(agent)
				}
					
			})
			//prioritize the users who has images by sorting the agent list
			teamMembers.sort((a,b) => { if(a.imageURL) return -1; return 1 } )
			//teamMembers.sort((a,b) => { if(this.isAgentOnline(a)) return -1; return 1 } )
			return (teamMembers || []).slice(0, this.maxUser)
		}
	}

}

</script>

<style lang="scss">
.agents-information {
	margin-bottom: 15px;
	.agents-pictures {
		text-align: center;
		$size: 50px;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 20px;
		.picture {
			display: inline-block;
			margin-left: -8px;
			vertical-align: middle;
			position: relative;
			&:first-child {
				margin-left: 0;
			}

			img {
				display: block;
				background: transparent;
			}
		}
		.rp-no-image {
			height: 50px;
			width: 50px;
			background: #eee;
			border-radius: 50px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-transform: capitalize;
		}
	}

	.offline-message {
		margin: 11px 0px 12px 0px;
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		text-align: left;
		line-height: 1.5;
		@include for-size(desktop-up){
			line-height: 1;
			margin: 30px 0px 16px 0px;
			font-size: 20px;
		}
	}
}
</style>
